"use strict";exports.__esModule=true;exports.default=void 0;var _default=function _default(array){return array.filter((function(param){return!!param})).length===array.length};exports.default=_default;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/core/src/fusion-events-wrapper/is-all-defined.js
// module id = scgy
// module chunks = 5